import fs from 'node:fs'
import path from 'node:path'
export function findStaticAssetFile(assetDir: string, componentName: string): string | undefined {
  if (!fs.existsSync(assetDir)) return undefined

  const isNestedComponentName = /[\\/]/.test(componentName)
  const nestedComponentName = componentName.split(/[\\/]/).filter(Boolean).join(path.sep)
  if (
    isNestedComponentName &&
    nestedComponentName &&
    !path.isAbsolute(componentName) &&
    !nestedComponentName.split(path.sep).includes('..')
  ) {
    for (const extension of ['.tsx', '.ts']) {
      const relPath = `${nestedComponentName}${extension}`
      const filePath = path.join(assetDir, relPath)
      if (fs.existsSync(filePath) && fs.statSync(filePath).isFile()) {
        return relPath
      }
    }
  }

  if (!isNestedComponentName && !componentName.includes('..') && !path.isAbsolute(componentName)) {
    for (const extension of ['.tsx', '.ts']) {
      const relPath = path.join(componentName, `index${extension}`)
      const filePath = path.join(assetDir, relPath)
      if (fs.existsSync(filePath) && fs.statSync(filePath).isFile()) {
        return relPath
      }
    }
  }

  return fs
    .readdirSync(assetDir, { withFileTypes: true })
    .find(
      (entry) =>
        entry.isFile() &&
        (entry.name.endsWith('.tsx') || entry.name.endsWith('.ts')) &&
        entry.name.replace(/\.(tsx|ts)$/, '') === componentName
    )?.name
}
